import { App } from 'antd';
import Icon from '../../../cpn/Icon';
import { useFYspjdPLDelMutation } from '../../../store/DianShangYeWuApi';
function ExpenseNodeDel(props) {
    const {modal,message} = App.useApp(); 
    const [submitDel] = useFYspjdPLDelMutation()  
    return (
        <Icon 
            type='delete' 
            onClick={() => {
                modal.confirm({
                    title: '点击确定将删除审批点',
                    content: '删除后请重新设置审批点！',
                    okText: '确认',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        submitDel({
                            fy_spjd_user_id:props.fy_spjd_user_id+'',
                        }).then((res) => {
                            // console.log(res);
                            if (res.data.Status === 'success') {
                                message.info('删除成功！');
                            }
                            if (res.data.Status === "fail") {
                                message.error('删除失败！'+res.data.Message)
                            }
                        })
                    },
                    onCancel() {
                        // console.log('Cancel');
                    },
                }); 
            }}
        />
    )
}

export default ExpenseNodeDel